import React, { useState } from "react"
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { IconButton } from "@material-ui/core";

function SecretCell(props){

    const {secret} = props;
    const [visible, setVisible] = useState(false)
    const invisiblePlaceholder = "●●●●●●●●●●●●"

    return(
        <span style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
            <span>{visible? secret : invisiblePlaceholder }</span><IconButton  size="small" onMouseDown={()=>setVisible(true)} onMouseLeave={()=>setVisible(false)} onMouseUp={()=>setVisible(false)} >{visible? <VisibilityIcon htmlColor="#3B5158"/> : <VisibilityOffIcon htmlColor="#3B5158"/>}</IconButton>
        </span>
    )
}

export {SecretCell}